import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { EventsApiService } from 'features/events';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { copyEvent } = EventsApiService();

export const useCopyEvent = () => {
    const { message } = App.useApp();

    return useMutation(
        (id: any) => {
            return copyEvent(id);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                message.success("event copied successfully");
            },
        },
    );
};
